import { IJob } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/job';
import { JobStatus } from '../../../../../redux/jobs/jobs.types';
import { MaybeUndef } from '../../../../../types/system';

export interface JobBasedOperation {
  job: MaybeUndef<IJob<any>>;
  filesNumber: number;
  filesSize: MaybeUndef<number>;
  progress?: number;
  status: MaybeUndef<JobStatus>;
}

export enum JobStartRequestStatus {
  Starting,
  StartFailed,
  Started,
  ProcessingFailed,
}

export type JobOperationStatus =
  | { status: JobStartRequestStatus.Starting }
  | { status: JobStartRequestStatus.Started; jobId: string }
  | { status: JobStartRequestStatus.StartFailed; error: any }
  | {
      status: JobStartRequestStatus.ProcessingFailed;
      error: any;
      jobId: string;
    };

export interface JobBasedOperationGroup {
  id: string;
  fileIdsList: string[];
  jobStartRequestStatus: JobOperationStatus;
}
